<template>
  <div class="bg-white rounded-2xl shadow-md p-4">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-bold text-gray-900">Solde année en cours</h3>
      <span :class="['inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium', statusClass]">
        {{ $t(`final_settlement.status.${finalSettlement.status}`) }}
      </span>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
      <StackedField label="Montant" :value="formatPrice(finalSettlement.price)" />
      <StackedField v-if="paid" label="Facture">
        <button @click="handleInvoiceClick" class="text-sm text-blue-400 underline cursor-pointer">
          Lien de la facture
        </button>
      </StackedField>
    </div>
  </div>
</template>

<script>
import { formatPrice, StackedField, toCamelCase } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { StackedField },
  props: ["finalSettlement"],
  computed: {
    ...mapGetters("finalSettlements", { settlementIsPaid: "isPaid", settlementStatusClass: "statusClass" }),
    paid() {
      return this.settlementIsPaid(this.finalSettlement);
    },
    statusClass() {
      return this.settlementStatusClass(this.finalSettlement);
    },
  },
  methods: {
    formatPrice,
    ...mapActions("finalSettlements", ["fetchInvoiceUrl"]),
    async handleInvoiceClick() {
      const response = await this.fetchInvoiceUrl({ id: this.finalSettlement.id });
      if (!response?.success) return;

      const invoiceUrl = toCamelCase(response.data).invoiceUrl;
      if (invoiceUrl) window.open(invoiceUrl, "_blank");
    },
  },
};
</script>
